import { MutationTree } from 'vuex';
import * as MT from './mutationTypes';
import { ISubFundState } from './state';
import { SubFund, PaginationMeta, SubFundFilter } from '../types';

/*--------------------------------------------------/
 * SubFund Mutations
 *--------------------------------------------------*/
export const SubFundMutations: ISubFundMutations = {
  [MT.SET_ORGANIZATION_SUB_FUNDS]: (
    state: ISubFundState,
    subFunds: SubFund[]
  ) => (state.subFunds = subFunds),
  [MT.SET_PAGINATION_META]: (
    state: ISubFundState,
    paginatedMeta: PaginationMeta
  ) => (state.subFundPaginationMeta = paginatedMeta),
  [MT.SET_ORGANIZATION_FILTER_SUB_FUNDS]: (
    state: ISubFundState,
    filterSubFunds: SubFund[]
  ) => (state.filterSubFunds = filterSubFunds),

  [MT.SET_APPLIED_SUB_FUND_FILTER]: (
    state: ISubFundState,
    appliedFilters: SubFundFilter
  ) => (state.appliedFilters = appliedFilters)
};

/*--------------------------------------------------/
 * SubFund Mutations Tree Interface
 *--------------------------------------------------*/
export interface ISubFundMutations extends MutationTree<ISubFundState> {
  [MT.SET_ORGANIZATION_SUB_FUNDS](
    state: ISubFundState,
    subFunds: SubFund[]
  ): void;
  [MT.SET_PAGINATION_META](
    state: ISubFundState,
    paginatedMeta: PaginationMeta
  ): void;
  [MT.SET_ORGANIZATION_FILTER_SUB_FUNDS](
    state: ISubFundState,
    filterSubFunds: SubFund[]
  ): void;
  [MT.SET_APPLIED_SUB_FUND_FILTER](
    state: ISubFundState,
    appliedFilters: SubFundFilter
  ): void;
}
